import { Outlet, useLocation } from "react-router-dom";
import saly from '../assets/images/saly.png';
import Logo from "../components/IconsPack/BiLogo";

const AuthLayout = () => {
    const location = useLocation();
    const path = location.pathname;

    console.log(path);
    let welcomeMessage = '';
    if (path === '/auth/signin') {
        welcomeMessage = 'Welcome Back';
    } else if (path === '/auth/signup') {
        welcomeMessage = 'Let\'s sign you up';
    } else if (path === '/auth/forgot-password') {
        welcomeMessage = 'Let\'s get you back in';
    } else if (path.includes('/reset-password/')) {
        welcomeMessage = 'Update password';
    }

    return (
        <div className="flex w-full h-screen flex flex-col items-center justify-center bg-white p-6 md:flex-row">
            <div className="w-full h-full flex flex-col items-start justify-center md:w-[50%]">
                <div className="h-full w-full flex flex-col items-center md:items-start">
                    <div className="h-[50px] flex items-center mb-8 md:mb-0">
                        <Logo />
                    </div>
                    <div className="flex justify-center w-full h-[95%]">
                        <div className="w-full flex flex-col items-center justify-center md:flex-none md:w-[60%]">
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
            <div className={`hidden w-[50%] h-full bg-primary rounded-[16px] flex flex-col justify-between md:block`}>
                <p className={`text-white text-[7rem] font-bold leading-[6rem] pt-[48px] pl-[48px]`}>
                    {welcomeMessage}
                </p>
                <img src={saly} className="h-[80%]" />
            </div>
        </div>
    );
}

export default AuthLayout;
